module.exports = __webpack_public_path__ + "bj1-1d45f70fab2c13f5331f34d7972c44c8.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/bj1.png
// module id = F6G/
// module chunks = client